import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import {TransitionProps} from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(props: TransitionProps & { children: React.ReactElement; }, ref: React.Ref,) {
    return <Slide direction="down" ref={ref} {...props} />;
});
export default function AlertDialogSlide({
                                             open,
                                             title = "",
                                             description = "",
                                             confirmText = "Да",
                                             cancelText = "Нет",
                                             onConfirm,
                                             onCancel,
                                         }) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onCancel}
            sx={{
                "& .MuiDialog-container": {
                    alignItems: "flex-start",
                    justifyContent: "center",
                },
                "& .MuiDialog-paper": {mt: 8},
            }} aria-describedby="alert-dialog-slide-description"
        >
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>{cancelText}</Button>
                <Button onClick={onConfirm} autoFocus>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
/*
export default function AlertDialogSlide({status = false}) {
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (status) {
            setOpen(true);
        }
    }, [status, handleClose])
    return (<React.Fragment>
        <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}
                sx={{
                    "& .MuiDialog-container": {
                        alignItems: "flex-start",
                        justifyContent: "center",
                    },
                    "& .MuiDialog-paper": {mt: 8,},
                }} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{""}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    У вас есть несохранённые изменения. Уйти со страницы?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Нет</Button>
                <Button onClick={handleClose}>Да</Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>);
}

 */